import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[nrMultiselectAieaProp]',
  standalone: true,
})
export class NrMultiselectAieaPropDirective implements AfterViewInit {
  @Input() ariaRequired!: boolean;

  constructor(private _el: ElementRef) {}

  ngAfterViewInit() {
    const inputElement = this._el.nativeElement.querySelector(
      '.p-hidden-accessible > input[role="combobox"]',
    );
    inputElement.setAttribute('aria-expanded', false);
    inputElement.setAttribute('aria-required', this.ariaRequired);
  }
}
